// Actions

export const FETCH_MAP_LAYERS_BY_PROJ_CAT_TREE = {
  request: () => 'FETCH_MAP_LAYERS_BY_PROJ_CAT_TREE_REQUEST',
  success: () => 'FETCH_MAP_LAYERS_BY_PROJ_CAT_TREE_SUCCESS',
  error: () => 'FETCH_MAP_LAYERS_BY_PROJ_CAT_TREE_ERROR'
};

export const FETCH_KML_BY_SOURCE_BOUNDINGBOX_ZOOM = {
  request: () => 'FETCH_KML_BY_SOURCE_BOUNDINGBOX_ZOOM_REQUEST',
  success: () => 'FETCH_KML_BY_SOURCE_BOUNDINGBOX_ZOOM_SUCCESS',
  error: () => 'FETCH_KML_BY_SOURCE_BOUNDINGBOX_ZOOM_ERROR'
};

export const FETCH_PROJECT_CATEGORIES = {
  request: () => 'FETCH_PROJECT_CATEGORIES_REQUEST',
  success: () => 'FETCH_PROJECT_CATEGORIES_SUCCESS',
  error: () => 'FETCH_PROJECT_CATEGORIES_ERROR'
};

export const MAP_VIEWPORT_PROPERTIES = {
  update: () => 'MAP_VIEWPORT_PROPERTIES_UPDATE'
};

export const SELECT_FEATURE = {
  success: () => 'SELECT_FEATURE_SUCCESS'
};

export const FETCH_MAP_LAYERS_BY_LAYER = {
  request: () => 'FETCH_MAP_LAYERS_BY_LAYER_REQUEST',
  success: () => 'FETCH_MAP_LAYERS_BY_LAYER_SUCCESS',
  error: () => 'FETCH_MAP_LAYERS_BY_LAYER_ERROR'
};

export const FETCH_MAP_LAYERS_BY_LAYER_SEARCH = {
  request: () => 'FETCH_MAP_LAYERS_BY_LAYER_SEARCH_REQUEST',
  success: () => 'FETCH_MAP_LAYERS_BY_LAYER_SEARCH_SUCCESS',
  error: () => 'FETCH_MAP_LAYERS_BY_LAYER_SEARCH_ERROR'
};

export const SEARCH_TEXT = {
  clear: () => 'SEARCH_TEXT_CLEAR'
};

export const MAP_LAYER = {
  select: () => 'MAP_LAYER_SELECT'
};

export const FEATURE_DESCRIPTION = {
  toggle: () => 'FEATURE_DESCRIPTION_TOGGLE'
};
